var map = {
	"./Facebookmessanger.vue": [
		"6704",
		"chunk-398ff0cf"
	],
	"./Instagramfeed.vue": [
		"ca298",
		"chunk-1ae5b8a1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6844";
module.exports = webpackAsyncContext;